export default __webpack_public_path__ + "img/accha/accha3_1500.jpg";